module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-01-en.4f9cbaf59e23a3e0fd3b9b91b21ba359.png";